<div class="media profile-media">
  <!-- <img class="b-r-10" style="height: 2.7em;" src="assets/mingob/avatar.jpg" alt=""> -->
  <img class="b-r-10" style="height: 2.7em;" [src]="fotografia" alt="">
  <div class="media-body"><span>{{perfil.usuario}}</span>
    <p class="mb-0 font-roboto">{{perfil.nombreyap}} <i class="middle fa fa-angle-down"></i></p>
  </div>
</div>
<ul class="profile-dropdown onhover-show-div">
  <!-- <li><a [routerLink]="['/detalle/perfil',ci]"><app-feather-icons [icon]="'user'"></app-feather-icons><span>Mi perfil </span></a></li> -->
  <li><a [routerLink]="'/detalle/perfil/*'"><app-feather-icons [icon]="'user'"></app-feather-icons><span>Mi File </span></a></li>
  <!-- <li><a href="#"><app-feather-icons [icon]="'file-text'"></app-feather-icons><span>Notas</span></a></li> -->
  <li><a (click)="open2(content2)"><app-feather-icons [icon]="'camera'"></app-feather-icons><span>Foto de perfil</span></a></li>
  <li><a (click)="open(content)"><app-feather-icons [icon]="'settings'"></app-feather-icons><span>Cambiar Clave</span></a></li>
  <li (click)="onLogout($event)"><a href="javascript:void(0)"><app-feather-icons [icon]="'log-in'"></app-feather-icons><span>Salir</span></a></li>
</ul>




<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-body">


      <h4 class="modal-title font-primary text-center" id="modal-basic-title">Cambiar Contraseña</h4>

      <br>

           <!-- Form -->
    <form  #usuForm="ngForm" (ngSubmit)="c('Save click')" autocomplete="off">

        <div class="form-row">
          <div class="col-md-12 mb-3">
            <label for="">Contraseña Actual</label>
              <input type="password" class="form-control text-uppercase fuente" name="cla1" [(ngModel)]="claveactual"  placeholder="Contraseña Actual" required>
          </div>
        </div>

        <div class="form-row">
          <div class="col-md-6 mb-3">
              <label for="">Nueva Contraseña</label>
                <input type="password" class="form-control text-uppercase fuente" name="cla2" [(ngModel)]="clavenueva1"  placeholder="Nueva Contraseña" required>
            </div>
          <div class="col-md-6 mb-3">
            <label for="">Repita la contraseña</label>
              <input type="password" class="form-control text-uppercase fuente" name="cla3" [(ngModel)]="clavenueva2"  placeholder="Repita la nueva contraseña" required>
          </div>

        </div>


        <div class="d-flex justify-content-center">
          <button class="btn btn-primary m-2 btn-sm" type="submit" [disabled]="usuForm.invalid">Guardar</button>
          <button class="btn btn-danger m-2 btn-sm" type="button" (click)="d('Cross click')">Cancelar</button>
        </div>

    </form>
    <!-- /form -->


  </div>
</ng-template>

<ng-template #content2 let-c="close" let-d="dismiss">
  <div class="modal-body">


            <!-- Form -->
            <form  #imaForm="ngForm" (ngSubmit)="c('Save click')" autocomplete="off">

      <h4 class="modal-title font-primary text-center" id="modal-basic-title">Cambiar Foto de Perfil</h4>

      <br>
      <div class="row">
        <div class="col-md-12">
          <div class="card hovercard text-center">
          <div class="cardheader"></div>
              <div class="user-image">
                <div class="avatar"><img alt="" [src]="url? url:fotografia" style="width: 15em;"></div>
                <div class="icon-wrapper" style="cursor: pointer !important;"><i class="icofont icofont-pencil-alt-5" style="color: #00a8ff;cursor:pointer !important" (click)="imgbtn.click()"><input class="upload" type="file"
                      (change)="readUrl($event)" #imgbtn accept="image/jpg, image/jpeg" required/></i></div>
                      <span *ngIf="url==null">Seleccione la Fotografia</span>
              </div>
            </div>
        </div>
      </div>

      <div class="d-flex justify-content-center">
        <button class="btn btn-primary m-2 btn-sm" type="submit" [disabled]="imaForm.invalid">Guardar</button>
        <button class="btn btn-danger m-2 btn-sm" type="button" (click)="d('Cross click')">Cancelar</button>
      </div>

  </form>
  <!-- /form -->


  </div>
</ng-template>
